import { Suspense } from "react";
import { Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { KYCUserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/KYCUserGroupMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { Permissions } from "../../../util/Permissions";
import { TroveNextManagement } from "./TroveNext";

const TroveNextPages = () => {
    return (
        <>
            <AsideMenu>
                <KYCUserGroupMenu destination="/trove-next" showCounts={false} />
            </AsideMenu>
            <Section>
                <Suspense fallback={<LayoutSplashScreen />}>
                    <Switch>
                        <ContentRoute
                            path="/trove-next/:userGroup/:statusTab?"
                            permission={Permissions.PENDING_KYC}
                            component={TroveNextManagement}
                        />
                    </Switch>
                </Suspense>
            </Section>
        </>
    );
};

export default TroveNextPages;
